import Agent from 'infrastructure/agent';
import { saveFile } from 'utils/app.util';

export const addCorrosionLog = () =>
  Agent.post('/IntegrityManagementCorrosion/upload');

export const loadCorrosionLogsByWell = (wellId) =>
  Agent.get(`/IntegrityManagementCorrosion/get-by-well-id/${wellId}`);

export const deleteCorrosionLog = (fileId) =>
  Agent.delete(`/IntegrityManagementCorrosion/delete/${fileId}`);

export const loadCorrosionLogFile = (fileId) =>
  Agent.file
    .get(`/IntegrityManagementCorrosion/download/${fileId}`)
    .then(([file, fileName]) => saveFile(file, fileName));

export const loadCorrosionLogTemplate = () =>
  Agent.file
    .get('/IntegrityManagementCorrosion/downloadTemplate')
    .then(([file, filename]) => saveFile(file, filename));

export const loadServiceProviders = () =>
  Agent.get('/IntegrityManagementProviderService');

export const loadCorrosionMeasureTools = () =>
  Agent.get('/IntegrityManagementCorrosionMeasureTool');

export const createServiceProviders = (serviceProvider) =>
  Agent.post('/IntegrityManagementProviderService', serviceProvider);

export const createCorrosionMeasureTool = (tool) =>
  Agent.post('/IntegrityManagementCorrosionMeasureTool', tool);

export const createNewCorrosionLog = (file, data) =>
  Agent.file.post('/IntegrityManagementCorrosion/upload', file, data);

export const loadCorrosionLogFilters = (files) =>
  Agent.post(
    '/IntegrityManagementCorrosionData/compare-files-options-data',
    files,
  );
export const loadCompareFilesData = (data) =>
  Agent.post('/IntegrityManagementCorrosionData/compare-files', data);

const CorrosionLogService = {
  loadCorrosionLogTemplate,
  addCorrosionLog,
  loadCorrosionLogsByWell,
  deleteCorrosionLog,
  loadCorrosionLogFile,
  loadServiceProviders,
  loadCorrosionMeasureTools,
  createServiceProviders,
  createCorrosionMeasureTool,
  createNewCorrosionLog,
  loadCorrosionLogFilters,
  loadCompareFilesData,
};

export default CorrosionLogService;
